import { GOMS_FULFILLMENT_CONSTANTS as types } from '@store/constants';


const initialState = {
  config: {
    data: null,
    isLoading: false,
    isError: false,
    error: null
  },
  onHoldFulfillments: {
    fulfillments: {
      data: null,
      isLoading: false,
      isError: false,
      error: null,
      totalPages: 0
    },
    fulfillmentDetails: {
      isLoading: false,
      isError: false,
      error: null,
      data: null
    }
  }
};


const gomsDashboardReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.GETTING_GOMS_CONFIG:
      return {
        ...state,
        config: {
          ...state.config,
          isLoading: true,
          isError: false,
          error: null,
          data: null
        }
      };

    case types.GET_GOMS_CONFIG_SUCCESS:
      return {
        ...state,
        config: {
          ...state.config,
          isLoading: false,
          isError: false,
          error: null,
          data: payload
        }
      };

    case types.GET_GOMS_CONFIG_FAILURE:
      return {
        ...state,
        config: {
          ...state.config,
          isLoading: false,
          isError: true,
          error: payload,
          data: null
        }
      };

    case types.GETTING_GOMS_ON_HOLD_FULFILLMENTS:
      return {
        ...state,
        onHoldFulfillments: {
          ...state.onHoldFulfillments,
          fulfillments: {
            ...state.onHoldFulfillments.fulfillments,
            isLoading: true,
            data: null,
            error: null,
            isError: false
          }
        }
      };

    case types.GET_GOMS_ON_HOLD_FULFILLMENTS_SUCCESS:
      return {
        ...state,
        onHoldFulfillments: {
          ...state.onHoldFulfillments,
          fulfillments: {
            ...state.onHoldFulfillments.fulfillments,
            isLoading: false,
            data: payload,
            error: null,
            isError: false
          }
        }
      };

    case types.GET_GOMS_ON_HOLD_FULFILLMENTS_FAILURE:
      return {
        ...state,
        onHoldFulfillments: {
          ...state.onHoldFulfillments,
          fulfillments: {
            ...state.onHoldFulfillments.fulfillments,
            isLoading: false,
            data: null,
            error: payload?.message,
            isError: true
          }
        }
      };

    case types.GETTING_GOMS_FULFILLMENT_BY_ID:
      return {
        ...state,
        onHoldFulfillments: {
          ...state.onHoldFulfillments,
          fulfillmentDetails: {
            ...state.onHoldFulfillments.fulfillmentDetails,
            isLoading: true,
            data: null,
            error: null,
            isError: false
          }
        }
      };

    case types.GET_GOMS_FULFILLMENT_BY_ID_SUCCESS:
      return {
        ...state,
        onHoldFulfillments: {
          ...state.onHoldFulfillments,
          fulfillmentDetails: {
            ...state.onHoldFulfillments.fulfillmentDetails,
            isLoading: false,
            data: payload,
            error: null,
            isError: false
          }
        }
      };

    case types.GET_GOMS_FULFILLMENT_BY_ID_FAILURE:
      return {
        ...state,
        onHoldFulfillments: {
          ...state.onHoldFulfillments,
          fulfillmentDetails: {
            ...state.onHoldFulfillments.fulfillmentDetails,
            isLoading: false,
            data: null,
            error: payload?.message || payload,
            isError: true
          }
        }
      };

    case types.FORCE_INITIATING_GOMS_FULFILLMENT:
      return {
        ...state,
        onHoldFulfillments: {
          ...state.onHoldFulfillments,
          fulfillments: {
            ...state.onHoldFulfillments.fulfillments,
            isLoading: true,
            data: null,
            error: null,
            isError: false
          }
        }
      };

    case types.FORCE_INITIATE_GOMS_FULFILLMENT_SUCCESS:
      return {
        ...state,
        onHoldFulfillments: {
          ...state.onHoldFulfillments,
          fulfillments: {
            ...state.onHoldFulfillments.fulfillments,
            isLoading: false,
            data: payload,
            error: null,
            isError: false
          }
        }
      };
    case types.FORCE_INITIATE_GOMS_FULFILLMENT_FAILURE:
      return {
        ...state,
        onHoldFulfillments: {
          ...state.onHoldFulfillments,
          fulfillments: {
            ...state.onHoldFulfillments.fulfillments,
            isLoading: false,
            data: null,
            error: payload?.message || payload,
            isError: true
          }
        }
      };

    case types.SET_GOMS_FULFILLMENTS_TO_INITIAL_STATE:
      return initialState;

    default:
      return state;
  }
};

export default gomsDashboardReducer;